export default "__VITE_ASSET__a91baeda__"